import { CircleX } from 'lucide-react'
import { SessionManager } from 'utils'

export default function ActionReject(props) {

    const { text, route_name, onClick } = props

    const permission = JSON.parse(SessionManager.getSession('permission'))

    return (
        <>
            {permission?.some(val => val.sub_action_name === route_name) &&
                <CircleX size={16} className='action_btn delete_btn text-secondary me-3'
                    onClick={onClick}
                    data-tooltip-id='global-tooltip'
                    data-tooltip-content={text}
                    data-tooltip-place="bottom"
                    data-tooltip-class-name='tl_red tooltip_msg'
                />
            }
        </>
    )
}